import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css'; // Main theme file
// import useLenis from './useLenis';

// Import your components and pages
import { Header } from './components/Header/Header';
import { Footer } from './components/Footer/Footer';
import HomePage from './pages/HomePage/HomePage';
import { HowItWorks } from './components/HowItWorks/HowItWorks';
import { Features } from './components/Features/Features'; // Assuming Features can also be a page
import { Contact } from './components/Contact/Contact';
import ChatScreen from './components/Chat/ChatScreen';
import { Privacy } from './pages/Privacy/Privacy';
import Terms from './pages/Terms/Terms';
import BlogPage from './pages/Blog/BlogPage';
import BlogPost from './pages/Blog/BlogPost';
import AdsList from './pages/Ads/AdsList'; // Adjust path if needed
import AdDetail from './pages/Ads/AdDetails';
import AboutPage from './pages/About/AboutPage';
import Faq from './pages/FAQ/Faq';
import { pageview } from './analytics';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PostAdFlow from './pages/PostAd/PostAdFlow';
import PostAdSuccess from './pages/PostAd/PostAdSuccess';
import EditAdPage from './pages/Ads/EditAd';
import MyAdsPage from './pages/Ads/MyAds';
import ProfilePage from './pages/Profile/Profile';
import { LocationProvider } from './contexts/LocationContext';
import AccountSettings from './pages/Settings/AccountSettings';
import ClaimAdsPage from './pages/ClaimAds/ClaimAds';
import { useFCM } from './hooks/useFCM';
import ToastContainer from './components/Toast/ToastContainer';
import NotificationsPage from './pages/Notifications/Notifications';



function App() {
  useFCM();
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    pageview(location.pathname + location.search);
  }, [location]);

  // useLenis()
  return (
    
    <LocationProvider>
      <div id="recaptcha-container"></div>
      <div className="app">

        <Header />
        <main>

          {/* The <Routes> component is where you define your pages */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/features" element={<Features />} />
            <Route path="/howitworks" element={<HowItWorks />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            {/* You can add a new page just by adding a new <Route> here */}
            {/* Example: <Route path="/about" element={<AboutPage />} /> */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/explore" element={<AdsList />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/chat" element={<ChatScreen />} />
            <Route path="/success/:adId" element={<PostAdSuccess />} />
            <Route path="/edit-ad/:adId" element={<EditAdPage />} />
            <Route path="/account-settings" element={<AccountSettings />} />
            <Route path="/claim-ads" element={<ClaimAdsPage />} />

            <Route
              path="/postad"
              element={

                <PostAdFlow />
              }
            />

            <Route path="/item/:id/:slug?" element={<AdDetail />} />
            <Route path="/my-ads" element={<MyAdsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
          </Routes>
        </main>
        <Footer />
        <ToastContainer />
      </div>
    </LocationProvider>
  );

}

export default App;
